/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delivery_Issue_TitleInputs */

const en_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item Delivery Issue`)
};

const ar_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشكلة في تسليم العنصر`)
};

const de_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem bei der Lieferung des Artikels`)
};

const es_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de entrega de artículos`)
};

const fr_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problème de réception d'article`)
};

const it_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema di consegna dell'articolo`)
};

const ja_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム送付に関する問題`)
};

const ko_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템 지급 이슈`)
};

const pt_br_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema na entrega do item`)
};

const ru_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблема с доставкой покупки`)
};

const th_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัญหาการส่งมอบไอเท็ม`)
};

const tr_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün Teslimat Sorunu`)
};

const zh_cn_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品发送异常`)
};

const zh_tw_dialog_delivery_issue_title = /** @type {(inputs: Dialog_Delivery_Issue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品發送異常`)
};

/**
* | output |
* | --- |
* | "Item Delivery Issue" |
*
* @param {Dialog_Delivery_Issue_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_delivery_issue_title = /** @type {((inputs?: Dialog_Delivery_Issue_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delivery_Issue_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_delivery_issue_title(inputs)
	if (locale === "ar") return ar_dialog_delivery_issue_title(inputs)
	if (locale === "de") return de_dialog_delivery_issue_title(inputs)
	if (locale === "es") return es_dialog_delivery_issue_title(inputs)
	if (locale === "fr") return fr_dialog_delivery_issue_title(inputs)
	if (locale === "it") return it_dialog_delivery_issue_title(inputs)
	if (locale === "ja") return ja_dialog_delivery_issue_title(inputs)
	if (locale === "ko") return ko_dialog_delivery_issue_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_delivery_issue_title(inputs)
	if (locale === "ru") return ru_dialog_delivery_issue_title(inputs)
	if (locale === "th") return th_dialog_delivery_issue_title(inputs)
	if (locale === "tr") return tr_dialog_delivery_issue_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_delivery_issue_title(inputs)
	return zh_tw_dialog_delivery_issue_title(inputs)
});